import Icon from '../../components/Icon.vue'

Icon.register({"brands/edge":{"width":512,"height":512,"paths":[{"d":"M25.7 228.2C25.8 228 25.9 227.8 26.1 227.7 26 227.8 26 228 26 228.2H25.7zM486.3 243.7C486.3 199.6 478.5 159.2 457.5 121.3 416.5 47.9 343.9 8 258.9 8 119 7.7 40.6 113.2 26.1 227.7 68.5 166.4 143.1 106.3 246.4 102.7 246.4 102.7 356.1 102.7 345.9 207.7H170C176.4 170.3 188.6 148.7 204.3 128.7 129.3 163.6 82.5 224.8 83.6 317.1 84.4 388.5 133.7 461.9 204.3 489 287.7 520.9 397.1 496.2 444.5 467.7V363.3C363.6 419.8 173.6 424.2 172.2 295.7H486.3V243.7z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-awesome@3.0.0@vue-awesome/icons/brands/edge.js
// module id = null
// module chunks = 